import React from 'react';

const ITEMS = [
  'No middleman',
  'Direct from the kitchen',
  'Real menus, real prices',
  'Zero markups',
  'Canadian independents',
  'Order direct',
  'Support local',
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-mono2 text-xs sm:text-sm uppercase tracking-[0.35em] text-[#a8a29e] px-8">
          {item}
        </span>
        <span aria-hidden="true" className="w-1.5 h-1.5 rounded-full bg-[#f15a24]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="relative border-y border-white/10 bg-[#0d0c0a] py-5 overflow-hidden"
    data-testid="editorial-marquee-container"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
